(function () {
	'use strict';
	$(document).ready(function () {

		function suggestListHandle(element) {
			var element = element;
			var text = element.text();

			var countryId = element.data('country-id');
			var stationId = element.data('station-id');

			var fieldName = element.closest('.suggest-list-parent').find('input').attr('name');

			if ($('.transport-form').length) {
				if (fieldName === 'kraj-nadania') {
					$('input#stacja-nadania').attr('data-country-id', countryId).val('');
				}

				if (fieldName === 'kraj-przeznaczenia') {
					$('input#stacja-przeznaczenia').attr('data-country-id', countryId).val('');
				}
			}

			if ($('.distances').length) {
				if (fieldName === 'stacja-nadania') {
					$('input#stacja-nadania').attr('data-station-id', stationId).val('');
				}

				if (fieldName === 'stacja-koncowa') {
					$('input#stacja-koncowa').attr('data-station-id', stationId).val('');
				}
			}

			element.closest('.suggest-list-parent').find('input').val(text);
			element.parent().remove();
		}

		$(document).on('click', '.suggest-list li', function() {
			suggestListHandle($(this));
		});

		$(document).on('keydown', function(e) {
			var suggestListOptionFocused = $('.suggest-list li.focused');
			if (suggestListOptionFocused.length && e.key === 'Enter') {
				e.stopPropagation();
				suggestListHandle(suggestListOptionFocused);
			}
		});

		$('.suggest-list-parent input').on('keyup', $.debounce(500,function(e) {

			var excludedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
			if (excludedKeys.includes(e.key)) {
				return;
			}

			var searchPhrase = $(this).val();
			var action = $(this).data('action');
			var countryId = $(this).attr('data-country-id');
			if (searchPhrase.length >= 2) {
				showSuggestList(action, searchPhrase, countryId, $(this));
			} else {
				$(this).closest('.suggest-list-parent').find('.suggest-list').remove();
				$(this).closest('.suggest-list-parent').find('input[data-country-id]').attr('data-country-id', '');
				$(this).closest('.suggest-list-parent').find('input[data-station-id]').attr('data-station-id', '');
			}

		}));

		$('.suggest-list-parent input').on('keydown', function(e) {
			var suggestList = $(this).closest('.suggest-list-parent').find('.suggest-list');
			var optionFocused = suggestList.find('li.focused');
			var optionFocusedFirst = suggestList.find('li:first-child').hasClass('focused');

			if (e.key === 'ArrowUp') {
				if (optionFocused.length && !optionFocusedFirst.length) {
					optionFocused.removeClass('focused');
					optionFocused.prev().addClass('focused');
				}
			}

			if (e.key === 'ArrowDown') {
				if (optionFocused.length) {
					optionFocused.removeClass('focused');
					optionFocused.next().addClass('focused');
				} else {
					suggestList.find('li:first-child').addClass('focused');
				}
			}

		});

		clickedOutside('.suggest-list', function (){
			$('.suggest-list').remove();
		}, ['.suggest-list li']);

		function showSuggestList(action, searchPhrase, countryId, element) {
			var element = element;
			var nonce = fhGetConfig('nonce');

			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				method: "post",
				timeout: 10000,
				data: {
					action: action,
					search_phrase: searchPhrase,
					country_id: countryId,
					nonce: nonce,
				},
				success: function (data) {
					element.closest('.suggest-list-parent').find('.suggest-list').remove();
					element.closest('.suggest-list-parent').append(data);
				}
			});
		}

	});
}(jQuery));
